import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-newstepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './newstepper.component.html',
  styleUrls: ['./newstepper.component.scss'],
})
export class NewStepperComponent implements OnInit, OnDestroy {
  @Input() activeStep: number = 0;

  actualStep = [
    'Arriendo',
    'Planes',
    'Datos del Propietario',
    'Inmueble',
    'Datos inquilino',
  ];
  actualStepMovil = [
    'Datos inquilino',
    'Planes',
    'Datos del Propietario',
    'Arriendo',
  ];
  nextStep = [
    'Planes',
    'Datos Propietario',
    'Inmueble',
    'Datos inquilino',
  ];
  nextStepMovil = [
    'Planes',
    'Datos del Propietario',
    'Inmueble',
    'Datos del inquilino',
  ];
  dynamicSteps = [
    'Arriendo',
    'Planes',
    'Datos Propietario',
    'Inmueble',
    'Datos inquilino',
  ];

  dynamicStepsMovil = [
    'Información Arriendo',
    'Planes',
    'Datos del Propietario',
    'Inmueble',
    'Datos del inquilino'
  ];

  resizeListener: any;

  constructor() {}

  ngOnInit(): void {
    this.resizeListener = this.handleResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }

  isMobile(): boolean {
    return window.innerWidth <= 1024;
  }

  handleResize() {
    console.log('Ventana redimensionada', window.innerWidth);
  }

  getCurrentSteps(): string[] {
    return this.isMobile() ? this.dynamicStepsMovil : this.dynamicSteps;
  }

  getNextStepText(): string {
    return this.isMobile()
      ? this.nextStepMovil[this.activeStep]
      : this.nextStep[this.activeStep];
  }
}
